import {Button, Tag} from "omoplay";
import InputGroup from "../form/InputGroup";
import {useRecoilValue} from "recoil";
import {accountSelector} from "../../store/selector/selector";
import OMOConnectImage from "../../assets/images/omo_connect_image.png";
import {postTermination} from "../../api/account/account.api";
import {useEffect, useState} from "react";
import KakaoIcon from "../../assets/images/kakao_icon.svg";
import MiniMenu from "../form/MiniMenu";

const ServicesPage = () => {
    const account = useRecoilValue(accountSelector);
    const [openMenuId, setOpenMenuId] = useState(null)

    /**
     * 아직 연동되지 않은 회원가입 신청. 서버 `GET /account` 가 내려준다(2026-09-10).
     *
     * 🔴 **이 값이 없으면 신청을 마친 고객이 `/wizard` 로 영구히 튕긴다.**
     * 신청이 `channel_install_request` 로 옮겨가면서 **연동 전 고객에게는 채널이 없다.**
     * 그래서 `channels.length === 0` 만으로는 "아직 신청 안 한 사람" 과
     * "신청하고 연동을 기다리는 사람" 이 구분되지 않는다.
     */
    const installRequest = account.installRequest
    const hasChannel = account.channels?.length > 0

    useEffect(() => {
        // 채널도 없고 신청도 없다 = 아무것도 시작하지 않은 신규 가입자. 신청 화면으로 보낸다.
        if (!hasChannel && !installRequest) {
            window.location.href = "/wizard"
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="flex-col gap-[32px]">
            <div className="flex-col flex-align-center gap-2">
                <div className="flex-col gap-4">
                    <div className="flex justify-end w-full">
                        <Button variants="primary" value="오모플레이 신청" size="large" onClick={() => window.location.href = "/wizard"} />
                    </div>
                    <div className="flex-col gap-4 overflow-y-scroll max-w-[1160px]" style={{height: "calc(100vh - 300px)"}} >
                        {/*
                          연동 전 신청 카드 (2026-09-10)

                          🔑 **채널이 없는 동안 고객이 볼 수 있는 유일한 진행 상태다.**
                             종전에는 신청 즉시 `account_channel` 이 생겨서 '채널 연동중' 태그가
                             채널 카드에 붙었다. 이제 채널이 없으므로 신청 자체를 카드로 보여준다.
                          🔑 상태 문구(`statusLabel`)는 **서버가 준다.** 프론트에 상태표를 복제하면
                             상태가 늘 때 두 곳을 고쳐야 하고, 빠뜨리면 빈 배지가 뜬다.
                        */}
                        {
                            !hasChannel && installRequest && (
                                <InputGroup label={
                                    <div className="flex-align-center gap-2">
                                        <div className="text-[18px]">{installRequest.displayName || "연동 준비중인 채널"}</div>
                                    </div>
                                }>
                                    <div className="flex flex-wrap gap-2">
                                        <div className="flex max-w-[550px] border rounded-lg border-[#dbdbea]">
                                            <div className="w-full bg-[#eaecef] rounded-l-lg">
                                                <img src={OMOConnectImage} alt="omo-connect" width={248} />
                                            </div>
                                            <div className="w-full flex-col justify-between text-gray-600 text-xs">
                                                <div className="flex-col gap-2 p-[16px]">
                                                    <div className="font-bold text-sm">오모플레이</div>
                                                    {/*
                                                      설치비 미결제(2026-10-12) — 사용자 규칙 "설치비를 결제하지 않은 고객은 이후 초기 세팅을
                                                      진행하지 않는다". 그래서 '연동 진행 중' 이 아니라 **결제가 먼저** 라고 말해 준다.
                                                      `setupPaid` 는 `GET /account` 요약이 준다(서버 `OauthAccount.InstallRequestSummary`).
                                                    */}
                                                    {installRequest.submittedByCustomer && !installRequest.setupPaid && !installRequest.backendDone
                                                        ? <div>초기 세팅비 결제가 확인되면 담당자가 카카오 채널 연동을 시작합니다.</div>
                                                        : <div>담당자가 카카오 채널 연동을 진행하고 있습니다.</div>}
                                                </div>
                                                <div className="flex justify-between w-[300px] p-[16px]">
                                                    <div className="flex-align-center justify-between w-full">
                                                        <div><Tag color="warning" size="large">{installRequest.statusLabel}</Tag></div>
                                                        {installRequest.submittedByCustomer && !installRequest.setupPaid && !installRequest.backendDone ? (
                                                            /* 결제만 남은 신청 — 위저드의 (6) 결제 화면으로 바로 보낸다('나중에 결제하기' 를 고른 고객의 복귀 경로). */
                                                            <Button variants="primary" value="설치비 결제하기" onClick={() => {
                                                                window.location.href = "/wizard?step=payment"
                                                            }} />
                                                        ) : (
                                                            /* 연동이 끝나야 누를 수 있다 — 지금 눌러도 진행할 수 없다. */
                                                            <Button variants="primary" disabled={true} value="신청하기" />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </InputGroup>
                            )
                        }
                        {
                            account.channels?.map(channel => {
                                let connectPermission

                                channel.permissions.forEach(permission => {
                                    if (permission.serviceType === "Connect") {
                                        connectPermission = permission
                                    }
                                })

                                /*
                                  카카오 채널 연동(발신프로필 발급)이 끝나지 않은 채널.

                                  이 상태에서는 메시지 발송이 불가능하므로 '신청하기' 를 눌러도 진행할 수 없다.
                                  종전에는 Connect 권한이 없다는 이유만으로 '신청하기' 버튼이 그대로 노출돼,
                                  고객이 눌렀다가 막히는 상태였다. 그래서 연동 여부를 **가장 먼저** 판정한다.

                                  hasProfileKey 는 서버가 account_channel.kakao_profile_key 유무로 내려준다.
                                */
                                const isLinking = channel.hasProfileKey === false

                                /*
                                  채널명과 검색용 아이디를 각각 쓴다(2026-08-20).
                                  종전에는 합성된 name("업체명(@검색용아이디)")을 "(" 기준으로 잘라 썼는데,
                                  오모플레이 연동 대기 채널은 검색용 아이디가 없어 앞 조각이 비어 버렸다
                                  (indexOf 가 -1 → substring 이 0 으로 클램프).
                                */
                                const displayName = channel.channelName || channel.name || "이름 미지정"
                                const displaySearchId = channel.channelIdName ? `(@${channel.channelIdName})` : ""

                                return (
                                    <InputGroup label={
                                        <div className="flex-align-center gap-2">
                                            <div className="flex-align-center">
                                                <div className="text-[18px]">{displayName}</div>
                                                <div className="text-[14px] text-tertiary font-medium">{displaySearchId}</div>
                                            </div>
                                            <img src={KakaoIcon} alt="kakao-icon" />
                                        </div>
                                    }>
                                        <div className="flex flex-wrap gap-2">
                                            <div className="flex max-w-[550px] border rounded-lg border-[#dbdbea]">
                                                <div className="w-full bg-[#eaecef] rounded-l-lg">
                                                    <img src={OMOConnectImage} alt="omo-connect" width={248} />
                                                </div>
                                                <div className="w-full flex-col justify-between text-gray-600 text-xs">
                                                    <div className="flex-col gap-2 p-[16px]">
                                                        <div className="font-bold text-sm">오모플레이</div>
                                                        <div>최고의 마케팅 도구 오모플레이</div>
                                                    </div>
                                                    <div className="flex justify-between w-[300px] p-[16px]">
                                                        {
                                                            /* 연동 미완료가 최우선 판정 — 아래 Connect 권한 분기보다 먼저 걸러야
                                                               '신청하기' 버튼이 노출되지 않는다. */
                                                            isLinking ? (
                                                                <div className="flex-align-center justify-between w-full">
                                                                    <div><Tag color="warning" size="large">채널 연동중</Tag></div>
                                                                    <Button variants="primary" disabled={true} value="신청하기" />
                                                                </div>
                                                            ) : connectPermission ? (
                                                                <div className="flex-align-center justify-between w-full">
                                                                    {
                                                                        connectPermission.grant === "PENDING" ? (<div><Tag color="warning" size="large">신청 완료</Tag></div>)
                                                                            : (connectPermission.grant === "TERMINATE" ? <div><Tag color="error" size="large">해지 신청</Tag></div> :
                                                                                <div><Tag color="info" size="large">운영중</Tag></div>)
                                                                    }
                                                                    {
                                                                        connectPermission.grant === "ADMIN" && (
                                                                            <div className="border rounded-[36px]">
                                                                                <MiniMenu
                                                                                    id={`connect_${connectPermission.id}_${channel.id}`}
                                                                                    openMenuId={openMenuId}
                                                                                    setOpenMenuId={setOpenMenuId}
                                                                                    deletedName="해지 신청"
                                                                                    disabledEdit={true}
                                                                                    onClickDelete={() => {
                                                                                        if(window.confirm("서비스 해지 신청을 하시겠습니까?\n원활한 진행을 위해 담당자가 빠른 시일 내에 연락 드리겠습니다.")) {
                                                                                            postTermination("Connect").then(() => {
                                                                                                alert("해지 신청이 완료되었습니다.")
                                                                                            })
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            ) : (
                                                                <div className="flex justify-end w-full">
                                                                    <Button variants="primary" value="신청하기" onClick={() => {
                                                                        window.location.href = `/settings/connect?id=${channel.id}`
                                                                    }} />
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            {/*
                                            <div className="flex max-w-[550px] border rounded-lg border-[#dbdbea]">
                                                <div className="w-full bg-[#eaecef] rounded-l-lg">
                                                    <img src={OMOAgentImage} alt="omo-agent" width={248} />
                                                </div>
                                                <div className="w-full flex-col justify-between text-gray-600 text-xs">
                                                    <div className="flex-col gap-2 p-[16px]">
                                                        <div className="font-bold text-sm">오모 Agent</div>
                                                        <div>AI로 간편하게 메시지 제작</div>
                                                    </div>
                                                    <div className="flex justify-between w-[300px] p-[16px]">
                                                        {
                                                            agentPermission ? (
                                                                <div className="flex-align-center justify-between w-full">
                                                                    {
                                                                        agentPermission.grant === "PENDING" ? (<div><Tag color="warning" size="large">신청 완료</Tag></div>)
                                                                            : (agentPermission.grant === "TERMINATE" ? <div><Tag color="error" size="large">해지 신청</Tag></div> :
                                                                                <div><Tag color="info" size="large">운영중</Tag></div>)
                                                                    }
                                                                    {
                                                                        agentPermission.grant === "ADMIN" && (
                                                                            <div className="border rounded-[36px]">
                                                                                <MiniMenu
                                                                                    id={`agent_${agentPermission.id}_${channel.id}`}
                                                                                    openMenuId={openMenuId}
                                                                                    setOpenMenuId={setOpenMenuId}
                                                                                    deletedName="해지 신청"
                                                                                    disabledEdit={true}
                                                                                    onClickDelete={() => {
                                                                                        if(window.confirm("서비스 해지 신청을 하시겠습니까?\n원활한 진행을 위해 담당자가 빠른 시일 내에 연락 드리겠습니다.")) {
                                                                                            postTermination("Agent").then(() => {
                                                                                                alert("해지 신청이 완료되었습니다.")
                                                                                            })
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            ) : (
                                                                <div className="flex justify-end w-full">
                                                                    <Button variants="primary" disabled={!info?.isAvailable} value="신청하기" onClick={() => {
                                                                        window.location.href = `/settings/agent?id=${channel.id}`
                                                                    }} />
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex max-w-[550px] border rounded-lg border-[#dbdbea]">
                                                <div className="w-full bg-[#eaecef] rounded-l-lg">
                                                    <img src={SimpleScreen} alt="omo-agent" width={248} />
                                                </div>
                                                <div className="w-full flex-col justify-between text-gray-600 text-xs">
                                                    <div className="flex-col gap-2 p-[16px]">
                                                        <div className="font-bold text-sm">오모 조인</div>
                                                        <div>깔끔한 디자인의 간편 로그인 화면</div>
                                                    </div>
                                                    <div className="flex justify-between w-[300px] p-[16px]">
                                                        {
                                                            screenPermission ? (
                                                                <div className="flex-align-center justify-between w-full">
                                                                    {
                                                                        screenPermission.grant === "PENDING" ? (<div><Tag color="warning" size="large">신청 완료</Tag></div>)
                                                                            : (agentPermission?.grant === "TERMINATE" ? <div><Tag color="error" size="large">해지 신청</Tag></div> :
                                                                                <div><Tag color="info" size="large">운영중</Tag></div>)
                                                                    }
                                                                    {
                                                                        screenPermission.grant === "ADMIN" && (
                                                                            <div className="border rounded-[36px]">
                                                                                <MiniMenu
                                                                                    id={`simple_${screenPermission.id}_${channel.id}`}
                                                                                    openMenuId={openMenuId}
                                                                                    setOpenMenuId={setOpenMenuId}
                                                                                    deletedName="해지 신청"
                                                                                    disabledEdit={true}
                                                                                    onClickDelete={() => {
                                                                                        if(window.confirm("서비스 해지 신청을 하시겠습니까?\n원활한 진행을 위해 담당자가 빠른 시일 내에 연락 드리겠습니다.")) {
                                                                                            postTermination("Screen").then(() => {
                                                                                                alert("해지 신청이 완료되었습니다.")
                                                                                            })
                                                                                        }
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            ) : (
                                                                <div className="flex justify-end w-full">
                                                                    <Button variants="primary" disabled={!info?.isAvailable} value="신청하기" onClick={() => {
                                                                        window.location.href = `/settings/screen?id=${channel.id}`
                                                                    }} />
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            */}
                                        </div>
                                    </InputGroup>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServicesPage